// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { FirmwareVersionMessage, FirmwareVersionMessageT } from './firmware-version-message';
import { FloorLabelMessage, FloorLabelMessageT } from './floor-label-message';


export enum ElevatorControllerInfoContent {
  NONE = 0,
  FloorLabelMessage = 1,
  FirmwareVersionMessage = 2
}

export function unionToElevatorControllerInfoContent(
  type: ElevatorControllerInfoContent,
  accessor: (obj:FirmwareVersionMessage|FloorLabelMessage) => FirmwareVersionMessage|FloorLabelMessage|null
): FirmwareVersionMessage|FloorLabelMessage|null {
  switch(ElevatorControllerInfoContent[type]) {
    case 'NONE': return null; 
    case 'FloorLabelMessage': return accessor(new FloorLabelMessage())! as FloorLabelMessage;
    case 'FirmwareVersionMessage': return accessor(new FirmwareVersionMessage())! as FirmwareVersionMessage;
    default: return null;
  }
}

export function unionListToElevatorControllerInfoContent(
  type: ElevatorControllerInfoContent, 
  accessor: (index: number, obj:FirmwareVersionMessage|FloorLabelMessage) => FirmwareVersionMessage|FloorLabelMessage|null, 
  index: number
): FirmwareVersionMessage|FloorLabelMessage|null {
  switch(ElevatorControllerInfoContent[type]) {
    case 'NONE': return null; 
    case 'FloorLabelMessage': return accessor(index, new FloorLabelMessage())! as FloorLabelMessage;
    case 'FirmwareVersionMessage': return accessor(index, new FirmwareVersionMessage())! as FirmwareVersionMessage;
    default: return null;
  }
}
